// export const {
//   getDetail,
//   getPaged,
//   getCount,
//   getInfiniteLoad,
//   create,
//   update,
//   archive,
//   unarchive,
// } = generatePromises<IAsset, number, ICreateAsset, IUpdateAsset>(
//   GENERATOR_PARAMS,
// );
export var _ = function () { };
